import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    public toastController: ToastController) { }

  async showToast(message: string, duration = 2000, cssClass = '') {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'bottom',
      cssClass,
    });
    toast.present();
  }
}
